import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { API_LOCALIZATIONS } from '../../../consts'
import { to } from '../../../utils/to'

export interface UpdateLocalizationPayload {
  name: string | null
  description: string | null
  category_label: string | null
  lineage: string | null
  images: string[] | null
  image_urls: string[] | null
}

export interface UpdateLocalizationResponse {
  time: string
}

export const updateLocalization = async (
  localizationId: string,
  payload: UpdateLocalizationPayload
) => {
  const request: AxiosRequestConfig = {
    url: `${API_LOCALIZATIONS}/${localizationId}`,
    method: 'PATCH',
    data: payload,
    headers: { 'content-type': 'application/json' },
    withCredentials: true,
  }

  return to<AxiosResponse<UpdateLocalizationResponse>, AxiosError>(axios(request))
}
